import { FinancialEntityBudget } from "@project/domain/models/budget/financial-entity-budget.model";

export class CreateFinancialEntityBudget {
    constructor(
        public name: FinancialEntityBudget["name"],
        public description: FinancialEntityBudget["description"],
        public financialEntityId: FinancialEntityBudget["financialEntityId"],
    ) {}
}
